import { useEffect, useState } from "react";
import { api } from "@/api";
import { RenderMarkdown } from "./ChatHelpers";
import { cn } from "@/lib/utils";

export function DevChat({ id }: { id: string }) {
  const [logs, setLogs] = useState<string | null>(null);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        api
          .chat({ id })
          .history.get()
          .then(({ data, error }) => {
            if (error) {
              console.error(error);
              return;
            }
            setLogs(data);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchLogs();
  }, [id]);

  const renderLog = (log: string) => {
    // start with <message role= ....>
    // const start = log.indexOf("<message role=");
    // const end = log.indexOf("</message>");
    // const message = log.substring(start, end + "</message>".length);
    return (
      // <RenderMarkdown content={log} />

      <div className="whitespace-pre-wrap">{log}</div>
    );
  };

  return (
    <div className="text-sm">
      {/* super hack, split at <message role= and then add it back */}
      {logs?.split(split_key).map((l, i) => (
        <ContentSection key={l}>
          {i > 0 ? renderLog(split_key + l) : l}
        </ContentSection>
      ))}
    </div>
  );
}

const ContentSection = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={cn(
        "p-2 rounded my-2 hover:opacity-100 hover:cursor-pointer border bg-secondary border-border",
        !open && "max-h-40 text-ellipsis overflow-scroll opacity-50",
      )}
      onClick={() => setOpen(!open)}
    >
      {children}
    </div>
  );
};

const split_key = "<message role=";
